import { Polyglot } from 'components/translate';

const LANGUAGES_PATH = 'user_languages';
const LANGUAGES = [
  { value: 'ar', name: 'arabian' },
  { value: 'de', name: 'german' },
  { value: 'en', name: 'english' },
  { value: 'es', name: 'spanish' },
  { value: 'fr', name: 'francais' },
  { value: 'it', name: 'italian' },
  { value: 'pt_BR', name: 'portuguese' },
  { value: 'ja', name: 'japanese' }
];

const languagesList = (path = LANGUAGES_PATH) => {
  const languages = LANGUAGES.map((item = { value: '' }) => ({
    ...item,
    label: Polyglot.t(`${path}.${item.value.toUpperCase()}`)
  }));

  return languages;
};

const translatedLanguageList = () => languagesList('supported_languages');

export { languagesList, translatedLanguageList };
